import { toDate } from "@/lib/format";
import type { SellerBilling, SellerBillingStatus } from "@/types";

/** Vencida e não paga. É o corte que decide bloqueio no próximo fechamento. */
export function isOverdue(billing: SellerBilling): boolean {
  if (billing.paid) return false;
  const due = toDate(billing.dueDate);
  return due != null && due.getTime() < Date.now();
}

/** O que a fatura cobra: a comissão do mês mais as dívidas acumuladas nela. */
export function amountOf(billing: SellerBilling): number {
  return billing.totalAmount ?? billing.platformFee ?? 0;
}

/**
 * Se o vendedor é parceiro de teste agora: as faturas dele nascem ignoradas,
 * sem a comissão do Zé Padoca.
 */
export function isTestPartner(status: SellerBillingStatus | null | undefined): boolean {
  return status?.isTestPartner === true;
}
